export default "/_next/static/images/8d6e5e16e17c3f224fea6001f00fce12.jpg";